import { createMuiTheme } from '@material-ui/core/styles';

export const theme = createMuiTheme({
  palette: {
    type: "dark",
    secondary: {
      main: 'rgba(60, 60, 60, 1)'
    },
    text: {
      secondary: 'rgba(144, 144, 144, 1)'
    }
  },
  overrides: {
    MuiOutlinedInput: {
      root: {
        '&$focused $notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.7)',
          borderWidth: 2
        },
      },
      input: {
        padding: '18.5px 14px',
        '&:-webkit-autofill': {
          WebkitBoxShadow: '0 0 0 100px rgba(50, 50, 50, 1) inset',
          WebkitTextFillColor: '#fff',
          caretColor: '#fff',
          borderRadius: 'inherit'
        }
      },
    },
    MuiSelect: {
      select: {
        '&:focus': {
          backgroundColor: 'inherit'
        }
      }
    },
    MuiPopover: {
      paper: {
        backgroundColor: '#202020'
      }
    }
    // MuiList: {
    //   root: {
    //     // boxShadow: '0px 5px 5px -3px rgb(0 0 0 / 20%), 0px 8px 10px 1px rgb(0 0 0 / 14%), 0px 3px 14px 2px rgb(0 0 0 / 12%)',
    //     backgroundColor: '#202020'
    //   }
    // }
  }
});